<pr-form
  title="Critères ESG"
  subtitle="Définissez vos préférences en matière d'investissement responsable"
  (submit)="onSubmit()"
>
  <form [formGroup]="form">
    <!-- Section 1: Taxonomie & Durabilité -->
    <div class="ea-esg-form__section">
      <h4 class="ea-esg-form__section-title">
        Alignement Taxonomie & Durabilité
      </h4>

      <!-- Taxonomie -->
      <div class="ea-esg-form__field">
        <label class="ea-esg-form__label">
          Dans votre investissement, vous souhaitez qu'au moins :
        </label>
        <div class="ea-esg-form__toggle-group">
          @for (option of taxonomyOptions; track option.id) {
            <button
              type="button"
              class="ea-esg-form__toggle-btn"
              [class.ea-esg-form__toggle-btn--active]="
                form.get('taxonomy')?.value === option.id
              "
              (click)="onToggleChange('taxonomy', option.id)"
            >
              {{ option.label }}
            </button>
          }
        </div>
        <p class="ea-esg-form__sublabel">
          soient alignés avec la « Taxonomie » environnementale,
        </p>
        <div class="ea-esg-form__info-box">
          <pr-icon name="info" [width]="16"></pr-icon>
          <span>{{ taxonomyInfo }}</span>
        </div>
      </div>

      <!-- Durabilité -->
      <div class="ea-esg-form__field">
        <label class="ea-esg-form__label">et :</label>
        <div class="ea-esg-form__toggle-group">
          @for (option of sustainabilityOptions; track option.id) {
            <button
              type="button"
              class="ea-esg-form__toggle-btn"
              [class.ea-esg-form__toggle-btn--active]="
                form.get('sustainability')?.value === option.id
              "
              (click)="onToggleChange('sustainability', option.id)"
            >
              {{ option.label }}
            </button>
          }
        </div>
        <p class="ea-esg-form__sublabel">
          soient considérés comme « durable ».
        </p>
        <div class="ea-esg-form__info-box">
          <pr-icon name="info" [width]="16"></pr-icon>
          <span>{{ sustainabilityInfo }}</span>
        </div>
      </div>
    </div>

    <!-- Section 2: Critères ESG à privilégier -->
    <div class="ea-esg-form__section">
      <h4 class="ea-esg-form__section-title">Critères ESG à privilégier</h4>

      <div class="ea-esg-form__field">
        <label class="ea-esg-form__label">
          Quel critère ESG souhaitez-vous privilégier dans votre investissement
          ?
        </label>
        <div class="ea-esg-form__checklist">
          @for (option of investmentOptions; track option.id) {
            <label class="ea-esg-form__checkbox-item">
              <input
                type="checkbox"
                [checked]="isOptionSelected('investments', option.id)"
                (change)="
                  onChecklistChange(
                    'investments',
                    option.id,
                    $any($event.target).checked
                  )
                "
              />
              <span>{{ option.label }}</span>
            </label>
          }
        </div>
      </div>
    </div>

    <!-- Section 3: Minimisation des impacts négatifs -->
    <div class="ea-esg-form__section">
      <h4 class="ea-esg-form__section-title">
        Minimisation des impacts négatifs
      </h4>

      <div class="ea-esg-form__field">
        <label class="ea-esg-form__label">
          Souhaitez-vous écarter des activités ayant des impacts
          environnementaux et/ou sociaux négatifs de votre investissement ?
        </label>
        <div class="ea-esg-form__switch-wrapper">
          <label class="ea-esg-form__switch">
            <input
              type="checkbox"
              [checked]="includeNonESG"
              (change)="onSwitchChange('includeNonESG', $event)"
            />
            <span class="ea-esg-form__switch-slider"></span>
          </label>
          <span class="ea-esg-form__switch-label">{{
            includeNonESG ? 'Oui' : 'Non'
          }}</span>
        </div>
      </div>

      @if (includeNonESG) {
        <div class="ea-esg-form__field">
          <label class="ea-esg-form__label">
            Sur quel(s) critère(s) souhaitez-vous minimiser vos impacts négatifs
            ?
          </label>
          <div class="ea-esg-form__checklist ea-esg-form__checklist--grid">
            @for (option of nonEsgInvestmentOptions; track option.id) {
              <label class="ea-esg-form__checkbox-item">
                <input
                  type="checkbox"
                  [checked]="isOptionSelected('nonESGInvestments', option.id)"
                  (change)="
                    onChecklistChange(
                      'nonESGInvestments',
                      option.id,
                      $any($event.target).checked
                    )
                  "
                />
                <span>{{ option.label }}</span>
              </label>
            }
          </div>
        </div>
      }
    </div>

    <!-- Section 4: Secteurs interdits -->
    <div class="ea-esg-form__section">
      <h4 class="ea-esg-form__section-title">Secteurs à éviter</h4>

      <div class="ea-esg-form__field">
        <label class="ea-esg-form__label">
          Je souhaite éviter d'investir dans les activités suivantes
        </label>
        <div class="ea-esg-form__checklist ea-esg-form__checklist--grid">
          @for (option of forbiddenInvestmentOptions; track option.id) {
            <label class="ea-esg-form__checkbox-item">
              <input
                type="checkbox"
                [checked]="isOptionSelected('investmentsForbiden', option.id)"
                (change)="
                  onChecklistChange(
                    'investmentsForbiden',
                    option.id,
                    $any($event.target).checked
                  )
                "
              />
              <span>{{ option.label }}</span>
            </label>
          }
        </div>
      </div>
    </div>
  </form>
</pr-form>
